export default __webpack_public_path__ + "scripts/resources/assignments/en/MolarityDensity/sucrose/species.json";